import React, { JSX } from 'react';
import Card from 'react-bootstrap/Card';
import { Button, Image, Nav } from "react-bootstrap";
import { Place } from "@mui/icons-material";
import {useDispatch, useSelector} from "react-redux";
import {FaUserCircle} from "react-icons/fa";
import {CgClose} from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import {toggleAuthModal, toggleMoreOptionsDrawer} from "app/store/slices/authSlice";
import {RootState} from "app/store";

//eslint-disable-next-line max-len
import {updateShowChangePickUpDetailsModal} from "app/store/slices/storeSlice";
import getBrandName from "app/shared/utils/BrandHelper";
import Constants from "app/shared/constants/constants";
import useAppUtil from "./useAppUtil";
import FooterNavbar from "./FooterNavbar";
import {ReactComponent as LocationsIcon} from "../../../assets/images/ebb_locations.svg";
import {ReactComponent as NutritionIcon} from "../../../assets/images/ebb_nutrition.svg";
import {ReactComponent as RecentOrdersIcon} from "../../../assets/images/ebb_recent_orders.svg";
import PickupScheduleButton from './PickupScheduleButton';

const MoreOptions = (): JSX.Element => {
    const { logoutHandler } = useAppUtil();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user, isGuest, configs} = useSelector((state: RootState) => state.auth);
    // eslint-disable-next-line max-len
    const {balanceAmount, balancePoints, firstName} = useSelector((state: RootState) => state.userInfo);
    // eslint-disable-next-line max-len
    const {
        storeDescription,
    } = useSelector((state: RootState) => state.stores);
    const {brandTitle, giftCardIcon} = getBrandName();
    const oncloseMoreOptions = () => {
        dispatch(toggleMoreOptionsDrawer(false));
    };

    const handleLogout = () => {
        dispatch(toggleAuthModal(false));
        dispatch(toggleMoreOptionsDrawer(false));
        logoutHandler();
    };

    const openLinkInNewTab = () => {
        oncloseMoreOptions();
        window.open(configs?.brandConfigs?.NUTRITION_URL, '_blank');
    };

    const renderButton = (label: string, icon: JSX.Element | null, onClick: () => void) => (
        <Button onClick={onClick} variant="link" className="mt-3 p-0 text-black text-decoration-none">
            <div className="d-flex justify-content-start align-items-center">
                {icon}
                <span className="sideMenuFont">{label}</span>
            </div>
        </Button>
    );

    const renderMyAccountButton = () => (
        <Nav.Link
            eventKey="8"
            className="d-flex flex-row justify-content-start align-items-end p-0 "
            onClick={() => {
                dispatch(toggleMoreOptionsDrawer(false));
                navigate("/myaccount");
            }}
        >
            <p className="sideMenuFont text-transform-none">My Account</p>
        </Nav.Link>
    );

    return (
        <Card className="h-100 moreOptions">
            <Card.Header>
                <div className="horizontalAlignCenter">
                    <Place fontSize="large" className="map-location-icon"/>
                    <div className="moreHeaderTextContent">
                        <span className="brandName">{brandTitle}</span>
                        <span>
                            <Button
                                disabled={storeDescription === "" || storeDescription === Constants.NO_LOCATION_SELECTED}
                                variant="primary-light"
                                type="button"
                                className="button-hover ml-0 m-0 border-0 p-0 pl-0"
                                onClick={() => {
                                    dispatch(toggleMoreOptionsDrawer(false));
                                    navigate("/");
                                }}
                            >
                                <strong className="font-main">{storeDescription}</strong>
                            </Button>
                        </span>
                        <span>
                            <PickupScheduleButton
                                onClick={() => {
                                    dispatch(toggleMoreOptionsDrawer(false));
                                    dispatch(updateShowChangePickUpDetailsModal(true));
                                }}
                                className="button-hover ml-0 m-0 border-0 p-0 pl-0 font-sub bg-transparent"
                            />
                        </span>
                    </div>
                </div>
            </Card.Header>
                <Card.Body className="ms-4 mobile-side-menu">
                        <CgClose className="float-end modalCloseBtn" size={25} onClick={() => dispatch(toggleMoreOptionsDrawer(false))}/>
                    <br/>
                {user && !isGuest && (
                    <>
                        <p className="ms-1 more-greeting">
                            <span className="greeting-prefix">Hello, </span>
                            <span className="greeting-name">{firstName}</span>
                            <span className="greeting-suffix">!</span>
                        </p>
                        <p
                            color="primary-light"
                            className="user-info m-0 ms-1"
                        >
                            Points:
                            {' '}
                            {balancePoints}
                        </p>
                        <p className="user-info m-0 ms-1">
                            Balance:
                            {' '}
                            $
                            {balanceAmount?.toFixed(2)}
                        </p>
                        <p className="user-info m-0 ms-1">
                            {renderMyAccountButton()}
                        </p>
                    </>
                )}
                    <div className="d-flex justify-content-start flex-column mt-2">
                        {renderButton("NUTRITION", <NutritionIcon className="brand-icons me-1" />, () => openLinkInNewTab())}
                        {renderButton("LOCATION", <LocationsIcon className="brand-icons me-1" />, () => {
                            oncloseMoreOptions();
                            navigate("/");
                        })}
                        {!isGuest && user && renderButton("RECENT ORDERS", <RecentOrdersIcon className="brand-icons me-1" />, () => {
                            oncloseMoreOptions();
                            navigate("/recentorders");
                        })}
                    {
                        renderButton("GIFT CARDS", <Image className="brand-icons me-1" src={giftCardIcon} alt="giftcard icon" />, () => {
                            oncloseMoreOptions();
                            navigate("/giftcards");
                        })
                    }
                        {!isGuest && user && renderButton("LOGOUT", <FaUserCircle size={18} className="primary-opt me-2 mx-1"/>, () => {
                            oncloseMoreOptions();
                            handleLogout();
                        })}
                    </div>
                </Card.Body>
            <Card.Footer className="p-0">
                <div className="more-options-footer">
                    <FooterNavbar />
                </div>
            </Card.Footer>
        </Card>
    );
};
export default MoreOptions;
